import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useMemo } from 'react';
import styles from './searchResultsSelectAll.module.scss';
export const SearchResultsSelectAll = ({ className, totalCount, isAllSelected, isSomeSelected, onChange, }) => {
    const text = useMemo(() => {
        const partial = `${totalCount} ${totalCount === 1 ? 'result' : 'results'}`;
        return partial.concat(totalCount >= 50 ? ' in the page' : '');
    }, [totalCount]);
    return (_jsxs("label", Object.assign({ className: classNames(className, styles.root) }, { children: [_jsx(Checkbox, { checked: isAllSelected, indeterminate: isSomeSelected, onChange: onChange }), _jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: text }))] })));
};
